import { Navigate, useLocation } from "react-router-dom";
import { RegisterModalOutlet } from "src/apps/shared/RegisterModalOutlet";
import { useAuthUser } from "src/auth/useAuth";

import { Loading } from "./Loading";

export const RequireAuth = () => {
  const { token, isAuthenticated, isLoadingUser } = useAuthUser();

  const location = useLocation();

  if (isLoadingUser && !token) {
    return <Loading name="RequireAuth - loading" />;
  }

  if (!isAuthenticated && !token) {
    return <Navigate state={{ from: location }} to="/login" />;
  }

  // Always render the same tree shape so the routed <Outlet/> never remounts.
  // RegisterModalOutlet renders <Outlet/> unconditionally and decides whether
  // to overlay the registration prompt itself. Previously this swapped between
  // <RegisterModalOutlet/> and a bare <Outlet/>, which remounted the entire
  // routed subtree on every isLoadingUser/registration toggle and caused every
  // query to refetch in a loop.
  return <RegisterModalOutlet />;
};
